import { useMemo } from 'react';
import { generateSvgId } from 'src/lib/svg';

export const useSvgId = () => {
  const id = useMemo(() => generateSvgId(), []);

  return id;
};
